import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/leaderShip";

export default class LeaderShipService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
